import { FinancialReviewDetail } from 'features/FinancialReview/pages';
import { Can } from 'components/Can';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

export default function FinancialReviewDetailPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <Can do="read" on="financial_review">
          <FinancialReviewDetail />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}
